import { $restoreEditorState, mergeRegister } from '@lexical/utils'
import {
  $addUpdateTag,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  COMMAND_PRIORITY_HIGH,
  HISTORY_MERGE_TAG,
  KEY_ENTER_COMMAND,
  type LexicalEditor,
  RootNode,
  SELECT_ALL_COMMAND,
} from 'lexical'
import styles from '../EmailEditor.module.scss'
import { $findSlot, $getSlots, $isEmptySlot } from '../nodes/SlotNode'
import { $structure } from '../validate/structure'

const LOCKED_SLOT = '[data-slot][contenteditable="false"]'

const ignoreLockedSlotPress = (event: MouseEvent) => {
  if (event.target instanceof Element && event.target.closest(LOCKED_SLOT)) {
    event.preventDefault()
  }
}

export const registerEditingBehaviour = (editor: LexicalEditor, onRejected: () => void): (() => void) => {
  const expected = editor.getEditorState().read($structure)
  return mergeRegister(
    editor.registerRootListener((root, previous) => {
      previous?.removeEventListener('mousedown', ignoreLockedSlotPress)
      root?.addEventListener('mousedown', ignoreLockedSlotPress)
    }),
    editor.registerNodeTransform(RootNode, () => {
      if ($structure() === expected) {
        return
      }
      $addUpdateTag(HISTORY_MERGE_TAG)
      $restoreEditorState(editor, editor.getEditorState())
      queueMicrotask(onRejected)
    }),
    editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        const selection = $getSelection()
        if (!$isRangeSelection(selection)) {
          return false
        }
        const slot = $findSlot(selection.anchor.getNode())
        if (slot && slot.isEditable() && slot.getAttrs().slotFormat === 'rich') {
          return false
        }
        event?.preventDefault()
        return true
      },
      COMMAND_PRIORITY_HIGH,
    ),
    editor.registerCommand(
      SELECT_ALL_COMMAND,
      () => {
        const selection = $getSelection()
        const slot = $isRangeSelection(selection) ? $findSlot(selection.anchor.getNode()) : null
        slot?.select(0, slot.getChildrenSize())
        return true
      },
      COMMAND_PRIORITY_CRITICAL,
    ),
    editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        $getSlots().forEach((slot) => {
          editor.getElementByKey(slot.getKey())?.classList.toggle(styles.slotEmpty, $isEmptySlot(slot))
        })
      })
    }),
  )
}
